import { POINT_STATUS } from '../../../../../hooks/useFairEditState';

// Fallback-цвет команды по stateId. Основной цвет берётся из team.color (бэк отдаёт hex с 1.0.48);
// генерим стабильный оттенок только для системных / удалённых из домена команд, где color == null.
export function teamColor(id) {
    if (id == null) return 'var(--line-2)';
    const hue = (Number(id) * 47) % 360;
    return `hsl(${hue}, 58%, 55%)`;
}

// Класс бейджа транзакции по её статусу (TransactionStatus).
const TX_STATUS_CLASS = {
    COMPLETED: 'tx-ok',
    WIN: 'tx-ok',
    LOSE: 'tx-lose',
    HOLD: 'tx-hold',
    EXPIRED: 'tx-exp'
};

export function txStatusClass(status) {
    return TX_STATUS_CLASS[status] || 'tx-ok';
}

// Чип статуса точки ярмарки (класс + подпись) по статусу модерации.
export function pointStatusChip(status) {
    if (status === POINT_STATUS.APPROVED) return { cls: 'fr-chip-ok', label: 'Подтверждена' };
    if (status === POINT_STATUS.CHANGES_REQUESTED) return { cls: 'fr-chip-edit', label: 'В редактировании' };
    return { cls: 'fr-chip-mod', label: 'На модерации' };
}
